import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {Hayzinvor} from './Hayzinvor';
import * as $ from 'jquery';
import {Globals} from '../globals';
import {TranslateServiceService} from '../translate-service.service';
import {HayzinvorArchive} from '../hayzinvor-archive/HayzinvorArchive';

@Component({
  selector: 'app-hayzinvor',
  templateUrl: './hayzinvor.component.html',
  styleUrls: ['./hayzinvor.component.scss']
})
export class HayzinvorComponent implements OnInit {
  hayzinvor: Hayzinvor;
  isShown: boolean = false;
// headerPic;
  somethingChanged: any;
  dataToSend: any;

  p: any = 1;
  page: any;
  collection: any[] = [];
  config: any = {
    slidesPerView: 3,
    spaceBetween: 20,
    slidesPerGroup: 1,
    loop: false,
    loopFillGroupWithBlank: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 1,
      }
    }
  };
  config2: any = {
    //  effect:'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: false,

    zoomToggle: false,
    setWrapperSize: true,

  };

  constructor(private http: HttpClient, private translateService: TranslateServiceService, private route: ActivatedRoute, public globals: Globals) {

  }

  ngOnInit() {


    this.changel();
    $(window).scrollTop(0);
    setTimeout(() => {


    }, 600);

    this.http.get<Hayzinvor>(this.globals.urlMain + 'handes', {
      params: {
        page: this.p,

      }

    }).subscribe(data => {
      this.hayzinvor = data;
      // this.headerPic = data.data.header_img;
    });
    // localStorage.setItem('headerImage', this.headerPic ) ;
  }

  toggleShow() {

    this.isShown = !this.isShown;

  }

  changel() {
    this.changeReq();

  }
  dateChanged(val: any) {
    var num;
    this.somethingChanged = val.value.toString().split(' ');
    if (this.somethingChanged[1] == 'Jan') {
      num = '01';
    } else if (this.somethingChanged[1] == 'Feb') {
      num = '02';
    } else if (this.somethingChanged[1] == 'Mar') {
      num = '03';
    } else if (this.somethingChanged[1] == 'Apr') {
      num = '04';
    } else if (this.somethingChanged[1] == 'May') {
      num = '05';
    } else if (this.somethingChanged[1] == 'Jun') {
      num = '06';
    } else if (this.somethingChanged[1] == 'Jul') {
      num = '07';
    } else if (this.somethingChanged[1] == 'Aug') {
      num = '08';
    } else if (this.somethingChanged[1] == 'Sep') {
      num = '09';
    } else if (this.somethingChanged[1] == 'Oct') {
      num = '10';
    } else if (this.somethingChanged[1] == 'Nov') {
      num = '11';
    } else if (this.somethingChanged[1] == 'Dec') {
      num = '12';
    }
    this.dataToSend = this.somethingChanged[3] + '-' + num + '-' + this.somethingChanged[2];
    // console.log(this.dataToSend)
    this.http.get<Hayzinvor>(this.globals.urlMain + 'handes', {
      params: {
        date: this.dataToSend
      }

    }).subscribe(data => {
      this.hayzinvor = data;
      // console.log(this.slider)
      var k = Number(data.data.lastHandes.data.pagination.total);
      this.collection = [];
      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }
    });
    $(window).scrollTop(0);
  }
  changeReq() {
    $(window).scrollTop(0);
    this.http.get<Hayzinvor>(this.globals.urlMain + 'handes', {
      params: {
        page: this.p,

      }

    }).subscribe(data => {
      this.hayzinvor = data;
      // console.log(this.slider)
      var k = Number(data.data.lastHandes.data.pagination.total);
      this.collection = [];
      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }


    });


  }

  sendXoragirId(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    var id = $(target).attr('data-id');

    // alert(id)
    this.http.get<Hayzinvor>(this.globals.urlMain + 'handes', {
      params: {
        data: id,
      }
    }).subscribe(data => {
      this.hayzinvor = data;
    });
    $('html, body').animate({
      scrollTop: $('.hayZinvorLast').offset().top
    });
  }

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }


  changeLanguage() {

    var imageLang = $('header .languages .options> p img[data-attr="hy"]').attr('src');

    this.translateService.langData('hy');
    localStorage.setItem('lang', 'hy');
    localStorage.setItem('langimageLang', imageLang);
    setTimeout(() => {
      var href = location.href;
      //  console.log(href)
      location.href = href;
      location.reload();
    }, 200);


  }
}
